(() => {
  const stateElement = document.getElementById('iglam-checkout-discount-state');
  if (!stateElement) return;
  const state = JSON.parse(stateElement.textContent);
  let pending = null;
  let replayingSubmit = false;

  const codesFromCart = (cart) => {
    const codes = (cart.discount_codes || []).map((entry) => entry.code);
    const applications = [
      ...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap((item) =>
        (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)
      ),
    ];
    codes.push(...applications.filter((entry) => entry.type === 'discount_code').map((entry) => entry.title));
    return [...new Map(codes.filter(Boolean).map((code) => [code.trim().toUpperCase(), code.trim()])).values()];
  };

  const renderCart = (cart, mainSection) => {
    const sections = cart.sections || {};
    const parser = new DOMParser();
    if (sections['cart-drawer']) {
      const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      const target = document.getElementById('CartDrawer');
      if (source && target) target.innerHTML = source.innerHTML;
    }
    if (mainSection && sections[mainSection]) {
      const source = parser.parseFromString(sections[mainSection], 'text/html').querySelector('cart-items');
      const target = document.querySelector('cart-items');
      if (source && target) target.innerHTML = source.innerHTML;
    }
  };

  const resetBankDiscount = () => {
    if (pending) return pending;
    pending = (async () => {
      const response = await fetch(`${state.cartUrl}.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) throw new Error('Unable to read cart');
      const cart = await response.json();
      const codes = codesFromCart(cart);
      if (!codes.some((code) => code.toUpperCase() === 'BANK5')) return;
      const mainSection = document.getElementById('main-cart-items')?.dataset.id;
      const sections = ['cart-drawer'];
      if (mainSection) sections.push(mainSection);
      const update = await fetch(`${state.updateUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: codes.filter((code) => code.toUpperCase() !== 'BANK5').join(','),
          sections,
          sections_url: window.location.pathname,
        }),
      });
      if (!update.ok) throw new Error('Unable to reset checkout discount');
      const updatedCart = await update.json();
      if (codesFromCart(updatedCart).some((code) => code.toUpperCase() === 'BANK5')) {
        throw new Error('Checkout discount is still applied');
      }
      renderCart(updatedCart, mainSection);
    })().catch((error) => {
      console.error('Cart discount refresh failed:', error);
    }).finally(() => {
      pending = null;
    });
    return pending;
  };

  resetBankDiscount();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) resetBankDiscount();
  });
  document.addEventListener('show.bs.offcanvas', (event) => {
    if (event.target.id === 'CartDrawer') resetBankDiscount();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData && codesFromCart(event.cartData).some((code) => code.toUpperCase() === 'BANK5')) {
        resetBankDiscount();
      }
    });
  }
  document.addEventListener('submit', async (event) => {
    if (replayingSubmit || !pending || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    const form = event.target;
    const submitter = event.submitter;
    await pending;
    const currentForm = document.getElementById(form.id) || form;
    const currentSubmitter = document.getElementById(submitter.id) || submitter;
    replayingSubmit = true;
    try {
      currentForm.requestSubmit(currentSubmitter);
    } finally {
      replayingSubmit = false;
    }
  }, true);
})();
